import { API_ENDPOINTS, createApiUrl, ServiceType } from 'src/contstant/apiEndpoints';
import { apiClient } from '../apiClient';
import {
  CheckUserPermissionsRequest,
  CheckUserPermissionsResponse,
  CreateUserRequest,
  CreateUserResponse,
  DeleteUserRequest,
  DeleteUserResponse,
  GetUsersRequest,
  GetUsersResponse,
  GetUserMetadataRequest,
  GetUserMetadataResponse,
  ListUsersRequest,
  ListUsersResponse,
  UpdateUserRequest,
  UpdateUserResponse,
} from 'src/types/orbit/User';

export const userService = {
  // Get all users
  getAll: (data: ListUsersRequest) => {
    return apiClient.get<ListUsersResponse>(
      ServiceType.ORBIT,
      createApiUrl(API_ENDPOINTS.ORBIT_SERVERICE.USERS.ALL(data.programId)),
      data,
    );
  },

  getUserById: (data: GetUsersRequest) => {
    return apiClient.get<GetUsersResponse>(
      ServiceType.ORBIT,
      createApiUrl(
        API_ENDPOINTS.ORBIT_SERVERICE.USERS.BY_ID(data.programId, data.userId),
      ),
      data,
    );
  },

  getUserMetadata: (data: GetUserMetadataRequest) => {
    return apiClient.get<GetUserMetadataResponse>(
      ServiceType.ORBIT,
      createApiUrl(
        API_ENDPOINTS.ORBIT_SERVERICE.USERS.METADATA(data.programId, data.userId),
      ),
      data,
    );
  },

  // // Create new user
  create: (data: CreateUserRequest) => {
    return apiClient.post<CreateUserResponse, CreateUserRequest>(
      ServiceType.ORBIT,
      createApiUrl(API_ENDPOINTS.ORBIT_SERVERICE.USERS.CREATE(data.programId)),
      data,
    );
  },

  // // Update user
  update: (data: UpdateUserRequest) => {
    return apiClient.put<UpdateUserResponse, UpdateUserRequest>(
      ServiceType.ORBIT,
      createApiUrl(
        API_ENDPOINTS.ORBIT_SERVERICE.USERS.UPDATE(data.programId, data.userId),
      ),
      data,
    );
  },

  delete: (data: DeleteUserRequest) => {
    return apiClient.delete<DeleteUserResponse>(
      ServiceType.ORBIT,
      createApiUrl(
        API_ENDPOINTS.ORBIT_SERVERICE.USERS.DELETE(data.programId, data.userId),
      ),
      data,
      data.deletedBy,
    );
  },
  checkUserPermission: (data: CheckUserPermissionsRequest) => {
    return apiClient.post<CheckUserPermissionsResponse, CheckUserPermissionsRequest>(
      ServiceType.ORBIT,
      createApiUrl(
        API_ENDPOINTS.ORBIT_SERVERICE.USERS.CHECK_USER_PERMISSION(
          data.programId,
          data.userId,
        ),
      ),
      data,
    );
  },
};
